import DashboardLink from '@/components/dashboard/dashboard-link/dashboard-link';
import DashboardNavigationBar from '@/components/dashboard/navigation-bar/dashboard-navigation-bar';
import MainContent from '@/components/main-layout/components/main-content/main-content';
import { ROUTE_ACCOUNT } from '@/constants/routes';
import { Box, Flex, Text } from '@cmpsr/components';
import AccountItem from '../common/account-item';
import AccountPanel from '../common/account-panel';
import CancelRenewalAction from './components/cancel-renewal-action/cancel-renewal-action';
import ModalCancelMembership from './components/modal-cancel-membership/modal-cancel-membership';
import ModalRenewMembership from './components/modal-renew-membership/modal-renew-membership';
import RenewMembershipAction from './components/renew-membership-action/renew-membership-action';
import useEditMembershipController from './edit-membership.controller';

export default function EditMembershipPage() {
  const {
    type,
    cancelAtPeriodEnd,
    usdPrice,
    renewalDate,
    showCancelMembershipModal,
    onShowCancelMembershipModal,
    onHideCancelMembershipModal,
    handleCancelMembership,
    showRenewMembershipModal,
    onShowRenewMembershipModal,
    onHideRenewMembershipModal,
    handleRenewMembership,
  } = useEditMembershipController();
  return (
    <>
      <DashboardNavigationBar />
      <MainContent>
        <DashboardLink href={ROUTE_ACCOUNT}>Account</DashboardLink>
        <Box
          py={{ base: 'spacer-4', md: 'spacer-8', lg: 'spacer-12' }}
          px={{
            base: 'spacer-5',
            md: 'spacer-8',
            lg: 'spacer-44',
            xl: 'spacer-60',
            xxl: 'spacer-80',
          }}
          maxWidth="1440px"
          marginX="auto"
        >
          <AccountPanel header="Membership">
            <Flex flexDirection="column" gap="spacer-4">
              <AccountItem label="type" value={`${type} membership`} />
              <AccountItem label="price" value={`$ ${usdPrice}/year (Billed annually)`} />
              <AccountItem label={cancelAtPeriodEnd ? 'membership end date' : 'renewal date'} value={renewalDate} />
            </Flex>
            <Flex
              flexDirection={{ base: 'column', lg: 'row' }}
              gap={{ base: 'none', lg: 'spacer-2' }}
              mt={{ base: 'spacer-6', lg: 'spacer-8' }}
            >
              {cancelAtPeriodEnd ? (
                <>
                  <Text variant="text-body-meta-regular" color="text-secondary">
                    Do you want to renew your plan?
                  </Text>
                  <RenewMembershipAction onClick={onShowRenewMembershipModal} />
                </>
              ) : (
                <>
                  <Text variant="text-body-meta-regular" color="text-secondary">
                    Plan automatically renews until cancelled.
                  </Text>
                  <CancelRenewalAction onClick={onShowCancelMembershipModal} />
                </>
              )}
            </Flex>
            {showCancelMembershipModal && (
              <ModalCancelMembership
                isOpen
                onCloseClick={onHideCancelMembershipModal}
                onCancelClick={handleCancelMembership}
              />
            )}
            {showRenewMembershipModal && (
              <ModalRenewMembership
                isOpen
                onCloseClick={onHideRenewMembershipModal}
                onRenewClick={handleRenewMembership}
              />
            )}
          </AccountPanel>
        </Box>
      </MainContent>
    </>
  );
}
